import { COLORS } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

const styles = createStyleSheet({
  dailySessionContainer: {
    marginBottom: 16,
  },
  dailySessionContentCard: {
    marginRight: 8,
    marginLeft: 8,
    marginBottom: 16,
  },
  dailySessionContentCardLocked: {
    border: '1px solid',
    borderColor: COLORS.ERROR.DEFAULT,
  },
});

export default styles;
